"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityValueCheckbox = exports.EntityValueCheckboxDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var utils_1 = require("@shapeable/utils");
var entity_value_1 = require("../../components/entities/entity-value");
var checkbox_1 = require("../../components/elements/checkbox");
var cls = (0, utils_1.classNames)('entity-value-checkbox');
exports.EntityValueCheckboxDefaultProps = {
  onChange: function () {}
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding: ", " ", " ", ";\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n    transition: background-color 0.3s;\n    ", "\n  "], ["\n    padding: ", " ", " ", ";\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n    transition: background-color 0.3s;\n    ", "\n  "])), theme_1.theme.UNIT(3), theme_1.theme.UNIT(3), theme_1.theme.UNIT(3, 2), theme_1.theme.UNIT(4), function (_a) {
    var checked = _a.checked;
    return checked && (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      background-color: #FFFCEE;\n    "], ["\n      background-color: #FFFCEE;\n    "])));
  }),
  tablet: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    flex-direction: row;\n    \n  "], ["\n    flex-direction: row;\n    \n  "])))
});
var CheckboxStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  "], ["\n  "]))),
  tablet: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    flex-basis: 40%;\n  "], ["\n    flex-basis: 40%;\n  "])))
});
var ValueStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    margin-left: ", ";\n  "], ["\n    margin-left: ", ";\n  "])), theme_1.theme.UNIT(1))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Checkbox: (0, styled_components_1.default)(checkbox_1.Checkbox)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), CheckboxStyles),
  Value: (0, styled_components_1.default)(entity_value_1.EntityValue)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ValueStyles)
};
var EntityValueCheckbox = function (props) {
  var _a;
  var className = props.className,
    children = props.children,
    checked = props.checked,
    loading = props.loading,
    onChange = props.onChange,
    entityValueProps = __rest(props, ["className", "children", "checked", "loading", "onChange"]);
  var created = ((_a = entityValueProps === null || entityValueProps === void 0 ? void 0 : entityValueProps.entity) === null || _a === void 0 ? void 0 : _a.created) && "Created: ".concat((0, utils_1.formatDateString)(entityValueProps.entity.created, 'MMM D YYYY'));
  return react_1.default.createElement(My.Container, {
    loading: loading,
    checked: checked,
    className: cls.name(className)
  }, react_1.default.createElement(My.Checkbox, {
    borderRadius: 4,
    checked: checked,
    loading: loading,
    onChange: onChange
  }, react_1.default.createElement(My.Value, __assign({}, entityValueProps, {
    subtitle: created,
    variant: created ? 'default' : 'small'
  }))), children);
};
exports.EntityValueCheckbox = EntityValueCheckbox;
exports.EntityValueCheckbox.defaultProps = exports.EntityValueCheckboxDefaultProps;
exports.EntityValueCheckbox.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;